import { apiFetch } from './apiFetch';

const riskService = {

    async getRiskFlags(payload) {
        const url = `${process.env.REACT_APP_API_URL}/RiskFlag/GetRiskFlag?deviceId=${encodeURIComponent(payload.deviceId)}`;

        const response = await apiFetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        });

        const body = await response.json().catch(() => null);

        // 404 means no risk flag data exists for this device (which is normal for new records)
        if (response.status === 404) {
            return null;
        }

        if (!response.ok) {
            const err = new Error(body?.message || `HTTP ${response.status}`);
            err.status = response.status;
            err.body = body;
            throw err;
        }
        return body;
    },

    async setRiskFlags(payload) {
        const url = `${process.env.REACT_APP_API_URL}/RiskFlag/SetRiskFlag`;

        const response = await apiFetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        const body = await response.json().catch(() => null);

        if (!response.ok) {
            const err = new Error(body?.message || `HTTP ${response.status}`);
            err.status = response.status;
            err.body = body;
            throw err;
        }
        return body;
    },

    async updateRiskFlags(payload) {
        const url = `${process.env.REACT_APP_API_URL}/RiskFlag/UpdateRiskFlag`;

        const response = await apiFetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        const body = await response.json().catch(() => null);

        if (!response.ok) {
            const err = new Error(body?.message || `HTTP ${response.status}`);
            err.status = response.status;
            err.body = body;
            throw err;
        }
        return body;
    },

    async deleteRiskFlags(payload) {
        const riskFlagId =
            typeof payload === 'object' && payload !== null ? payload.riskFlagId ?? payload.id : payload;

        const url = `${process.env.REACT_APP_API_URL}/RiskFlag/DeleteRiskFlag?riskFlagId=${encodeURIComponent(riskFlagId)}`;

        const response = await apiFetch(url, {
            method: 'DELETE',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        });

        const body = await response.json().catch(() => null);

        if (!response.ok) {
            const err = new Error(body?.message || `HTTP ${response.status}`);
            err.status = response.status;
            err.body = body;
            throw err;
        }
        return body;
    }
};

export default riskService;
